import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import SignatureModal from './signatureModal';
import logValueOnChange from '../commonActions/logValueOnChange';
const SignatureField = _ref => {
  let enabled = _ref.enabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Signature' : _ref$label,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {
      _download: ''
    } : _ref$value,
    onChange = _ref.onChange,
    path = _ref.path,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? null : _ref$testingIdentifie;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  const handleChange = file => {
    if (!file) {
      onChange({
        path,
        value: null,
        displayValue: 'removed signature'
      });
      return;
    }
    const newValue = {
      _cache: file.cachedUrl,
      _download: file.fileName
    };
    const displayValue = newValue._download;
    onChange({
      path,
      value: newValue,
      displayValue
    });
  };
  const handleOpen = () => {
    if (!enabled) return;
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };

  /* eslint-disable-next-line no-underscore-dangle */
  const sigSrc = typeof value._cache !== 'undefined' ? value._cache : null;
  const signatureDisplayStyle = {
    width: '100%',
    height: '111px',
    maxWidth: '100%'
  };
  const signatureDisplay = sigSrc ? /*#__PURE__*/React.createElement("img", {
    alt: "signature",
    className: "t-sf-img",
    "data-testid": "t-sf-img",
    src: sigSrc,
    style: signatureDisplayStyle
  }) : /*#__PURE__*/React.createElement("div", {
    className: "t-sf-div",
    "data-testid": "t-sf-div",
    style: _objectSpread(_objectSpread({}, signatureDisplayStyle), {}, {
      display: 'block'
    })
  }, "\xA0");
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testingIdentifier,
    className: testingIdentifier
  }, /*#__PURE__*/React.createElement(Label, {
    style: {
      display: 'block'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: enabled ? 'pointer' : 'not-allowed'
    },
    className: "t-sf-add-signature tqc-control form-control",
    onClick: handleOpen,
    onKeyPress: handleOpen,
    role: "button",
    tabIndex: 0
  }, signatureDisplay), /*#__PURE__*/React.createElement(SignatureModal, {
    isOpen: isModalOpen,
    onHide: handleClose,
    onChange: handleChange,
    enabled: enabled
  }));
};
SignatureField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testingIdentifier: PropTypes.string,
  value: PropTypes.shape({
    _download: PropTypes.string,
    _cache: PropTypes.string
  })
};
export { SignatureField as UncomposedSignatureField };
export default entityComposition(SignatureField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});